import { useState, useRef, useEffect } from 'react';
import { X } from 'lucide-react';
import { useAnalytics } from '@/shared/features/analytics/presentation/hooks/useAnalytics';

interface VideoCallStickyBarProps {
  itemsCount: number;
  maxCount: number;
  message?: string;
}

export function VideoCallStickyBar({ itemsCount, maxCount, message }: VideoCallStickyBarProps) {
  const [dismissed, setDismissed] = useState(false);
  const prevCountRef = useRef(itemsCount);

  useEffect(() => {
    // If bar was dismissed and itemsCount increases, reset dismissed
    if (dismissed && itemsCount > prevCountRef.current) {
       
      setTimeout(() => setDismissed(false), 0);
    }
    prevCountRef.current = itemsCount;
  }, [itemsCount, dismissed]);
  const { analytics } = useAnalytics();

  if (itemsCount <= 0 || dismissed) return null;

  const displayMessage =
    message || `${itemsCount}/${maxCount} design(s) in trial cart`;

  return (
    <>
      {/* Mobile sticky bar */}
      <div className="fixed bottom-[68px] left-5 right-[100px] z-[93] animate-[slideUp_0.2s_ease-out_forwards] md:hidden">
        <div className="flex items-center gap-2 rounded-md bg-white px-2.5 py-2.5 shadow-[0_0_10px_rgba(0,0,0,0.3)]">
          <button
            type="button"
            aria-label="Dismiss video call bar"
            className="flex h-8 w-8 shrink-0 items-center justify-center text-gray-500"
            onClick={() => setDismissed(true)}
          >
            <X className="h-5 w-5" aria-hidden />
          </button>

          <span className="flex-1 text-sm text-gray-700">{displayMessage}</span>

          <a
            href="/tah?cartType=videoCallTah"
            className="shrink-0 rounded bg-[#5ba10f] px-4 py-1.5 text-sm font-semibold text-white"
            onClick={() => analytics?.trackEvent('Schedule Video Call CTA Clicked', {})}
          >
            Book
          </a>
        </div>
      </div>

      {/* Desktop sticky bar */}
      <div className="fixed bottom-6 right-[10%] z-[93] hidden animate-[slideUp_0.2s_ease-out_forwards] md:block">
        <div className="flex items-center gap-4 rounded-md bg-white px-4 py-3 shadow-[0_0_12px_rgba(0,0,0,0.2)]">
          <button
            type="button"
            aria-label="Dismiss video call bar"
            className="flex h-8 w-8 shrink-0 items-center justify-center text-gray-500"
            onClick={() => setDismissed(true)}
          >
            <X className="h-5 w-5" aria-hidden />
          </button>

          <span className="flex-1 text-sm font-medium text-gray-700">{displayMessage}</span>

          <a
            href="/tah?cartType=videoCallTah"
            className="shrink-0 rounded bg-[#5ba10f] px-6 py-2.5 text-sm font-bold uppercase tracking-wide text-white"
            onClick={() => analytics?.trackEvent('Schedule Video Call CTA Clicked', {})}
          >
            Book Video Call
          </a>
        </div>
      </div>
    </>
  );
}
